import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.app.notifications.supported,
    props.app.notifications.registered,
    props.app.notifications.button,
    props.user.user,
    (supported, registered, button, user) => {
        return {
            supported,
            registered,
            button,
            user
        }
    }
)